import { render, staticRenderFns } from "./task-profile-material-report.vue?vue&type=template&id=55ff8374&"
import script from "./task-profile-material-report.vue?vue&type=script&lang=js&"
export * from "./task-profile-material-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports